import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import AdList from 'components/Ad/List';

const ScreenAdList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <AdList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};
export default ScreenAdList;
